// Operaciones · Incidencias (docs/108 B12): la bandeja consolidada de TODAS las OD — notas con
// incidencia (carga con diferencias, facturación fallida), rechazos y entregas parciales que piden NC
// y pasos orquestados fallidos. Cada una se resuelve en su OD (doble clic la abre).
import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { api } from '../api/cliente';
import { PanelError } from '../comun/Estados';
import { Grilla } from '../comun/Grilla';
import { fecha } from '../comun/formato';
import { useSesion } from '../sesion/SesionContexto';

interface Incidencia {
  odId: string;
  odNumero: number;
  fecha: string;
  estadoOd: string;
  notaId: string | null;
  nota: string | null;
  cliente: string | null;
  tipo: string;
  detalle: string;
  requiereNc: boolean;
}

const NOMBRE: Record<string, string> = {
  INCIDENCIA: 'Incidencia',
  RECHAZO: 'Rechazo total',
  ENTREGA_PARCIAL: 'Entrega parcial',
  REQUIERE_NC: 'Requiere NC',
};

export function IncidenciasOd({
  alAbrirOd,
}: {
  alAbrirOd: (odId: string, numero: number) => void;
}) {
  const { empresa } = useSesion();
  const empresaId = empresa!.id;
  const [tipo, setTipo] = useState('');
  const q = useQuery({
    queryKey: ['emp', empresaId, 'logistica', 'incidencias'],
    queryFn: () => api.get<Incidencia[]>('/logistica/incidencias', { query: { empresaId } }),
  });
  const filas = (q.data ?? []).filter(
    (i) => !tipo || i.tipo === tipo || (tipo === 'PASO' && i.tipo.startsWith('PASO_')),
  );
  return (
    <div className="pantalla consulta" data-pantalla="incidencias-od">
      <div className="barra-filtros">
        <label className="campo">
          <span className="etiqueta">Tipo</span>
          <select
            aria-label="Tipo de incidencia"
            value={tipo}
            onChange={(e) => setTipo(e.target.value)}
          >
            <option value="">Todas</option>
            {Object.entries(NOMBRE).map(([k, v]) => (
              <option key={k} value={k}>
                {v}
              </option>
            ))}
            <option value="PASO">Paso orquestado fallido</option>
          </select>
        </label>
        <span className="espaciador" />
        <span>
          {filas.length} incidencias · {filas.filter((i) => i.requiereNc).length} piden NC
        </span>
      </div>
      {q.isError && <PanelError error={q.error} />}
      <Grilla
        etiqueta="Incidencias de las órdenes de despacho"
        columnas={[
          {
            id: 'od',
            titulo: 'ODD',
            celda: (i) => <span className="mono">ODD {i.odNumero}</span>,
            ancho: '6rem',
          },
          { id: 'f', titulo: 'Fecha', celda: (i) => fecha(i.fecha), ancho: '7rem' },
          {
            id: 'e',
            titulo: 'Estado ODD',
            celda: (i) => i.estadoOd.toLowerCase().replace(/_/g, ' '),
            ancho: '8rem',
          },
          { id: 'n', titulo: 'Nota', celda: (i) => i.nota ?? '', ancho: '8rem' },
          { id: 'c', titulo: 'Cliente', celda: (i) => i.cliente ?? '' },
          {
            id: 't',
            titulo: 'Tipo',
            celda: (i) =>
              NOMBRE[i.tipo] ?? i.tipo.replace('PASO_FALLIDO_', 'paso fallido · ').toLowerCase(),
            ancho: '11rem',
          },
          { id: 'd', titulo: 'Detalle', celda: (i) => i.detalle },
          { id: 'nc', titulo: 'NC', celda: (i) => (i.requiereNc ? 'sí' : ''), ancho: '4rem' },
        ]}
        filas={filas}
        clave={(i) => `${i.odId}:${i.notaId ?? ''}:${i.tipo}`}
        cargando={q.isLoading}
        vacio="Sin incidencias abiertas"
        alAbrir={(i) => alAbrirOd(i.odId, i.odNumero)}
        autofoco
      />
    </div>
  );
}
